import { Component, Inject, OnInit } from '@angular/core';
import {
  BrandingV2Service,
  FREE_SUBSCRIPTION_ID,
  VBP2_STARTUP_SUBSCRIPTION_ID,
  WhitelabelService,
} from '@galaxy/partner';
import { ButtonAction, FormOptions } from '@vendasta/vform';
import { combineLatest, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { PartnerService } from '../../core/partner.service';
import { BrandingAndApps } from '../../core/user-branding.service';

@Component({
  selector: 'app-customize-partner',
  templateUrl: './customize-partner.component.html',
  styleUrls: ['./customize-partner.component.scss'],
})
export class CustomizePartnerComponent implements OnInit {
  bcsFormOptions: FormOptions = {
    leftCustomButtons: [
      { label: 'Apply Changes', action: ButtonAction.SUBMIT, color: 'primary', disableWhenFormInvalidOrLoading: true },
    ],
    formUrl: '/form/v1/partner/business-center-settings',
    context: {},
  };

  gpsFormOptions: FormOptions = {
    leftCustomButtons: [
      { label: 'Save', action: ButtonAction.SUBMIT, color: 'primary', disableWhenFormInvalidOrLoading: true },
    ],
    formUrl: '/form/v1/partner/general-product-settings',
    context: {},
  };

  salesFormOptions: FormOptions = {
    leftCustomButtons: [
      { label: 'Submit', action: ButtonAction.SUBMIT, color: 'primary', disableWhenFormInvalidOrLoading: true },
      { label: 'Cancel', action: ButtonAction.CANCEL },
    ],
    formUrl: '/form/v1/customize-design/sales-tool',
    context: {},
  };

  esFormOptions: FormOptions = {
    leftCustomButtons: [
      { label: 'Apply Changes', action: ButtonAction.SUBMIT, color: 'primary', disableWhenFormInvalidOrLoading: true },
    ],
    formUrl: '/form/v1/customize-design/email-settings',
    context: {},
  };

  brandingAndApps$: Observable<BrandingAndApps>;
  showUpgradeCTA$: Observable<boolean>;

  constructor(
    private whitelabelService: WhitelabelService,
    private brandingService: BrandingV2Service,
    private partnerService: PartnerService,
    @Inject('PARTNER_ID') readonly partnerId$: Observable<string>,
  ) {}

  ngOnInit(): void {
    const brandingV2$ = this.partnerId$.pipe(switchMap((partnerId) => this.brandingService.getBranding(partnerId)));
    const brandingV1$ = this.partnerId$.pipe(switchMap((partnerId) => this.whitelabelService.getBranding(partnerId)));

    this.brandingAndApps$ = combineLatest([brandingV1$, brandingV2$]).pipe(
      map(([b1, b2]) => {
        return {
          faviconUrl: b2?.faviconUrl,
          shortcutIconUrl: b2?.shortcutIconUrl,
          logoUrl: b2?.logoUrl,
          uiTheme: b2?.uiTheme,
          primaryColor: b2?.primaryColor,
          name: b2?.name,
          apps: b1?.apps,
        };
      }),
    );

    this.showUpgradeCTA$ = this.partnerService.subscriptionTier$.pipe(
      map((currentTier) => FREE_SUBSCRIPTION_ID === currentTier.id || currentTier.id === VBP2_STARTUP_SUBSCRIPTION_ID),
    );
  }
}
